import { Button, ButtonMode, Modal, ModalWidth, useGlobalModalContext } from '@creditsights/styleguide-web';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ConfirmSkipOnboardingModal = (): React.ReactElement => {
  const { closeModal, store } = useGlobalModalContext();
  const navigate = useNavigate();

  const renderFooter = () => (
    <>
      <Button dataTestId="skip-onboarding-cancel-button" onClick={closeModal} mode={ButtonMode.SECONDARY}>
        Cancel
      </Button>
      <Button
        onClick={() => {
          navigate('/feed/global', { replace: true });
        }}
        dataTestId="skip-onboarding-confirm-button"
        mode={ButtonMode.PRIMARY}
      >
        Skip
      </Button>
    </>
  );

  return (
    <Modal width={ModalWidth.Small} open onClose={closeModal} headerTitle="Skip Onboarding" footer={renderFooter()} data-testid="skip-onboarding-modal" error={store.props.error}>
      <p>Are you sure you want to skip onboarding? Any information you’ve entered will be lost.</p>
    </Modal>
  );
};

export default ConfirmSkipOnboardingModal;
